import React, { useEffect, useState } from "react";
import * as APIModels from "../../../../models";
import { TylerAdminService } from "../../../../services/ClientService";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

export default function AttorneModal(params: {
    close: () => void;
    addAttorneyModal: boolean;
    updateAttorney: (u: APIModels.Attorney) => Promise<void>;
    updating: APIModels.Attorney;
    message: string;
}): JSX.Element {
    const [updateAttorney, setUpdateAttorney] = useState(
        {} as APIModels.Attorney
    );
    useEffect(() => {
        setUpdateAttorney(params.updating);
    }, [params.updating]);

    return (
        <div>
            <Modal show={params.addAttorneyModal}>
                <Form>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "Blue" }}>
                            Update an Attorney
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group as={Row}>
                            <Form.Group as={Col}>
                                <Form.Label>First Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="First Name"
                                    value={updateAttorney.firstName}
                                    onChange={(e) => {
                                        setUpdateAttorney({
                                            ...updateAttorney,
                                            firstName: e.target.value,
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Last Name"
                                    value={updateAttorney.firstName}
                                    onChange={(e) => {
                                        setUpdateAttorney({
                                            ...updateAttorney,
                                            lastName: e.target.value,
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>Bar Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="0000AAAA"
                                    value={updateAttorney.barNumber}
                                    onChange={(e) => {
                                        setUpdateAttorney({
                                            ...updateAttorney,
                                            barNumber: e.target.value,
                                        });
                                    }}
                                />
                            </Form.Group>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="submit"
                            className="btn btn-success"
                            onClick={(e) => {
                                e.preventDefault();
                                params
                                    .updateAttorney(updateAttorney)
                                    .then(() => {
                                        if (params.message.length === 0) {
                                            params.close;
                                        }
                                    });
                            }}
                            style={{ float: "left" }}
                        >
                            <i className="" /> Update
                        </button>
                        {params.message && params.message != "" ? (
                            <p style={{ color: "red", float: "none" }}>
                                {params.message}
                            </p>
                        ) : (
                            <></>
                        )}
                        <Button
                            variant="secondary"
                            onClick={() => params.close()}
                            style={{ float: "right" }}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}
